export const linkStyle = {
  padding: '5px 20px',
};

export const activeLinkStyle = {
  color: '#FF9E0C',
  background: '#24282F',
  borderRadius: '10px',
};
